"use client"

import { useEffect } from "react"

interface CodexMobileDetailSheetProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const CodexMobileDetailSheet = ({
  isOpen,
  onClose,
  children,
}: CodexMobileDetailSheetProps) => {
  // Prevent body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
    return () => {
      document.body.style.overflow = ""
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <>
      {/* Backdrop - z-[100] to be above side sheet */}
      <div
        id="codex-mobile-detail-backdrop"
        className="fixed inset-0 bg-black/70 z-[100] backdrop-blur-sm animate-in fade-in duration-200"
        onClick={onClose}
      />

      {/* Bottom Sheet - z-[101] */}
      <div
        id="codex-mobile-detail-sheet"
        className="fixed bottom-0 left-0 right-0 z-[101] bg-gradient-to-b from-slate-900 to-slate-950 border-t-2 border-amber-600/50 shadow-2xl shadow-black/50 rounded-t-2xl max-h-[85vh] flex flex-col animate-in slide-in-from-bottom duration-300"
      >
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-12 h-1 bg-gray-600 rounded-full" />
        </div>

        {/* Close button (X) in top-right */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition p-2"
          aria-label="Close details"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Content - scrollable */}
        <div className="flex-1 overflow-y-auto px-6 pb-6">
          {children}
        </div>
      </div>
    </>
  )
}
